// @owners { team: patient-health }
// eslint-disable-next-line @alto/no-pocky-import
import { Button, FlexColumn, FlexRow, Text, palette, spacing } from '@alto/pocky';
import autobind from 'autobind-decorator';
import React from 'react';
import styled from 'styled-components';
import { type Transfer } from '~shared/types/clients';
import { MedTransferModal } from './MedTransferModal';
import UserTag from '~web/features/family-accounts/components/UserTagContainer';

type Props = {
  readonly cancelTransfer: (arg0: Transfer) => void;
  readonly transfer: Transfer;
};

type State = {
  isCancelModalShowing: boolean;
};

const MedListTransferRowContainer = styled(FlexColumn).attrs({
  spacing: spacing.xsSpacing,
  evenlySpaceContent: true,
})`
  align-items: center;
  border: ${spacing.borderWidth} solid ${palette.grey2};
  border-radius: ${spacing.borderRadius};
  padding: ${spacing.smSpacing} ${spacing.mdSpacing};
`;

const MedNamesContainer = styled(FlexRow)`
  /*
   * these rows are nested inside an outer container,
   * this forces the buttons in the list to align.
   */
  margin-right: ${spacing.mdSpacing};
`;

const DeleteButton = styled(Button)`
  justify-content: center;
`;

export default class MedListTransferRow extends React.PureComponent<Props, State> {
  state = {
    isCancelModalShowing: false,
  };

  // @ts-expect-error error TS1270: Decorator function return type 'void | TypedPropertyDescriptor<unknown>' is not assignable to type 'void | (() => void)'
  @autobind
  cancelTransfer() {
    this.props.cancelTransfer(this.props.transfer);
    this.setState({
      isCancelModalShowing: false,
    });
  }

  // @ts-expect-error error TS1270: Decorator function return type 'void | TypedPropertyDescriptor<unknown>' is not assignable to type 'void | (() => void)'
  @autobind
  toggleDeleteModal() {
    this.setState(({ isCancelModalShowing }) => ({
      isCancelModalShowing: !isCancelModalShowing,
    }));
  }

  render() {
    const {
      transfer: { medications, user_id },
    } = this.props;
    const { isCancelModalShowing } = this.state;

    return (
      <MedListTransferRowContainer>
        <MedNamesContainer>
          <Text>Medication Name(s): {medications}</Text>
          <UserTag userIDs={[user_id]} />
        </MedNamesContainer>

        <DeleteButton
          kind="secondary"
          danger
          // eslint-disable-next-line @typescript-eslint/unbound-method
          onClick={this.toggleDeleteModal}
        >
          Cancel transfer
        </DeleteButton>

        {isCancelModalShowing ? (
          <MedTransferModal
            // eslint-disable-next-line @typescript-eslint/unbound-method
            cancelTransfer={this.cancelTransfer}
            // eslint-disable-next-line @typescript-eslint/unbound-method
            toggleDeleteModal={this.toggleDeleteModal}
          />
        ) : null}
      </MedListTransferRowContainer>
    );
  }
}
